import { CACHE_AUDIO, CACHE_ALL_AUDIO, PURGE_AUDIO } from '../constants/ActionTypes'

/**
 * @typedef {ReturnType<typeof cacheAudio> | ReturnType<typeof purgeAudio> | ReturnType<typeof cacheAllAudio>} AudioCacheActions
 */

/**
 * @param {string} storageUrl
 * @param {string} publicUrl
 * @return {{ type: 'CACHE_AUDIO', storageUrl: string, publicUrl: string, timestamp: number }}
 */
export const cacheAudio = (storageUrl, publicUrl) => ({
  type: CACHE_AUDIO,
  storageUrl,
  publicUrl,
  timestamp: new Date().getTime(),
})

/**
 * @param {Record<String, String>} cache
 * @return {{ type: 'CACHE_ALL_AUDIO', cache: Record<String, String>, timestamp: number }}
 */
export const cacheAllAudio = (cache) => {
  return {
    type: CACHE_ALL_AUDIO,
    cache,
    timestamp: new Date().getTime(),
  }
}

/**
 * @param {string} storageUrl
 * @return {{ type: 'PURGE_AUDIO', storageUrl: string }}
 */
export const purgeAudio = (storageUrl) => ({
  type: PURGE_AUDIO,
  storageUrl,
})
